import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'chart',
  template: `
    <ui-view></ui-view>
  `,
  styleUrls: ['chart.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChartComponent { }